module.exports = __webpack_public_path__ + "img/VL_12_01.1be7efb2.png";